import { administrationRequests } from "api/administrationApi";
import React from "react";
import { FunctionField, ReferenceField } from "react-admin";

const RoomField = ({ label = "Зала", source = "roomId", render = rec => `${rec.roomName} - ${rec.buildingName}` }) => {
  return (
    <ReferenceField
      source={source}
      label={label}
      reference={administrationRequests.getRoomsSelect()}
      emptyText="-"
    >
      <FunctionField
        label={label}
        render={render}
      />
    </ReferenceField>
  );
};

export default RoomField;
